﻿import { Directive } from "@app/components/directive";
import { ITabsController, ITabsScope } from "@app/components/kb-tabs/kb-tabs.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { IAugmentedJQuery } from "angular";

export interface ITabScope extends ng.IScope {
    value: any;
    label: string;
    invalid: boolean;
    selected: boolean;
    visible: boolean;
    icon: string;
    image: string;
    imageWhenSelected: string;
    sortIndex?: number;
    verticalStretch: boolean;

    _tabsScope: ITabsScope;
    _getElement: () => IAugmentedJQuery;
}

@NgComponent({
    token: Token.KbTab,
    dependencies: [
    ]
})
export class KbTab extends Directive {
    constructor() {
        super();

        this.require = "^kbTabs";
        this.replace = true;
        this.template = Dirs.component("kb-tab");
        this.restrict = "AE";
        this.scope = {
            value: "=",
            label: "@",
            invalid: "=?",
            selected: "=?",
            visible: "=?",
            icon: "@",
            image: "@",
            imageWhenSelected: "@",
            sortIndex: "=?", // specify a sort value (weight) for each tab, otherwise they will be sorted in the order they are registered
            verticalStretch: "=?",
        };
        this.transclude = true; 

        this.compile = (element, atts: any) => {
            if (atts.visible == null) atts.visible = "true";
            return this.link;
        };

        this.link = (scope: ITabScope, element, atts: any, tabsCtrl: ITabsController) => {
            scope._getElement = () => {
                return element;
            };
            scope._tabsScope = tabsCtrl.scope;
            tabsCtrl.registerTab(scope);

            scope.$watch("visible", () => tabsCtrl.tabVisibleChanged(scope));
        };
    }
}
